import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HospitalDoctorContactComponent } from './hospital-doctor-contact.component';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [
    HospitalDoctorContactComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    SharedModule
  ],
  exports: [
    HospitalDoctorContactComponent
  ]
})
export class HospitalDoctorContactModule { }
